import manager from 'ub/fonts/font-service/manager.js';
const absoluteUrl = new RegExp('^(?:[a-z]+:)?//', 'i');

const clearRelativeUrl = (node) => {

  const bgImageProperty = node.style.backgroundImage;
  const extractedUrl =  bgImageProperty.startsWith('url') ? bgImageProperty.match(/\((.*?)\)/)[1].replace(/('|")/g,'') : null; //extract background-image url if exists

  if (absoluteUrl.test(extractedUrl)) {
    return; //return if valid absolute url
  }

  const backgroundStyleString = node.style.background;

  if (backgroundStyleString) {
    node.style.background = backgroundStyleString.replace(node.style.backgroundImage, '');
  } else {
    node.style.backgroundImage = '';
  }

};

const cleanElementsInPlace = (elementsList) => {
  Array.from(elementsList).forEach(clearRelativeUrl);
};

const nodesToHtml = (nodesList) => {
  return Array.from(nodesList)
    .map((child) => {
      return child.outerHTML;
    })
    .join('');
};

export default function backgroundStyleStringCleaner(contentHtml) {
  const contentElements = manager.getHtmlAsNodeList(contentHtml);
  cleanElementsInPlace(contentElements.querySelectorAll('[style*=background]')); //removes all background related styling
  return nodesToHtml(contentElements.children);
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/background-style-cleaner.js